import React, { Component } from "react";
import AppUtils from "../../../apputils";
//import {EventDetail } from "../../models/users";
import { GetEventsList, EventDetail, SitemapEventsList } from "../../../models/events";
import { GetToursList } from "../../../models/tour";
import { PnkConnect } from "../../../pnk-react/pnk-miniredux";
//import Sitemap from "../../sitemap";
import { CreateEvent } from "../CreateEvent";
import AllEventsPage from "./all-events";



class allEvents extends Component {
    constructor() {
        super()
        this.state = {
            getEvents: true,
            eventslist: [],
            event_id: '',
            EventDetails: false,
            getSitemapEventList:false,
            getSitemapTourList:false,
            EventDetailsData: {}
        }
    }

    CreateEvent = () => {
        this.ShowCreateEventModal();
    }

    ShowCreateEventModal = () => {
        this.props.componentprops.OpenModal(CreateEvent, 'md', { modalClass: 'profile-entry-modal', headerClass: 'profile-entry-header', titleClass: 'profile-entry-title', close: this.CloseModal, title: 'Add Event', action: 'Create' }, { action: 'Create', name: 'Create', Close: this.CloseModal })
    }

    ShowProfileModal = () => {
        this.props.componentprops.OpenModal(CreateEvent, 'md', { modalClass: 'profile-entry-modal', headerClass: 'profile-entry-header', titleClass: 'profile-entry-title', title: 'Add Lead Source', action: 'Detail', data: this.state.EventDetailsData, close: this.CloseModalTwo }, { action: 'Detail', name: 'Detail', close: this.CloseModalTwo })
    }

    CloseModalTwo = ()=>{
        this.props.componentprops.HandleCloseModal();
        this.setState({
            getEvents: true
        });
    }


    CloseModal = () => {
        // console.log(JSON.parse(sessionStorage.getItem('session_list')))
        if(localStorage.getItem('tour_list') !== null && localStorage.getItem('tour_list') !== undefined && localStorage.getItem('tour_list') !== ''){
            this.setState({
                getEvents: true,
                getSitemapEventList: true
            });
    
        }

        else{
            this.setState({
                getEvents: true,
                getSitemapEventList: true,
                getSitemapTourList:true
            });
    
        }
        this.props.componentprops.HandleCloseModal();
      
    }

    GetEventDetails = (id) => {

        this.setState({
            event_id: id,
            EventDetails: true,
        })


    }

    HandleGetToursSitemapListSuccessResponse = (res)=>{

        let tours_list = []
        if (res !== false) {
            res.data.tourslist.rows.map((item) => {
                tours_list.push({ "id": item.tour_seo_url})
            })
 
            localStorage.setItem("tour_list", JSON.stringify(tours_list));
 
        }
      
        this.setState({
            getSitemapTourList: false
        })
 

    }


    HandleGetSitemapEventsListSuccessResponse = (res) => {
    //    alert('IN SITEMAP');
       let sessions_list = []
       if (res !== false) {
           res.data.eventslist.rows.map((item) => {
               sessions_list.push({ "id": item.seo_url})
           })

           localStorage.setItem("session_list", JSON.stringify(sessions_list));

           window.open('https://www.kinshipliving.com/sitemap')
         //  window.focus()
       }
     
       this.setState({
           getSitemapEventList: false
       })
   }




    HandleEventsListSuccessResponse = (res) => {

        if (res !== false) {
           //  console.log(JSON.stringify(res))
            this.setState({
                getEvents: false,
                eventslist: res.data.eventslist.rows
            })
        }

        else {
            this.setState({
                getEvents: false
            })
        }
    }

    HandleGetEventDetailsSuccessResponse = (res) => {
        if (res !== false) {
            // console.log(res.data.eventdetails.rows);
            this.setState({
                EventDetailsData: res.data.eventdetails.rows,
                EventDetails: false,
                event_id: ''

            })
            this.ShowProfileModal();

        }

        else {
            this.setState({
                EventDetails: false,
                event_id: ''
            })
        }
    }


    render() {
        return (
            <div>
                {localStorage.getItem('current_user_profile') !== null && localStorage.getItem('current_user_profile') === 'admin' ?
                    <AllEventsPage {...this.props} eventslist={this.state.eventslist}
                        GetEventDetails={this.GetEventDetails}
                        ShowProfileModal={this.ShowProfileModal}
                        ShowCreateEventModal={this.ShowCreateEventModal}
                        CreateEvent={this.CreateEvent}
                    />
                    : AppUtils.HandlePageClick(this.props.componentprops, 'home')
                }
                {((this.state.getSitemapTourList === true) ? GetToursList(this.props.PnkStore, this.HandleGetToursSitemapListSuccessResponse) : "")}
                {((this.state.getSitemapEventList === true) ? SitemapEventsList(this.props.PnkStore, this.HandleGetSitemapEventsListSuccessResponse) : "")}    
                {((this.state.getEvents === true) ? GetEventsList(this.props.PnkStore, this.HandleEventsListSuccessResponse) : "")}
                {((this.state.EventDetails === true) ? EventDetail(this.props.PnkStore, this.state.event_id, this.HandleGetEventDetailsSuccessResponse) : "")}
            </div>
        )
    }
}

export const AllEvents = PnkConnect(allEvents, '');